module.exports = __webpack_public_path__ + "img/cp4-6.8ac2af18.jpg";